import { useState } from "react";
import { useSetRecoilState } from "recoil";

import InputRadio from "components/atoms/input/Radio";
import InputText from "components/atoms/input/Text";
import Buttons from "components/atoms/buttons";

import useInput from "hooks/useInput";
import { InputForm } from "types/Form";

import useLoginUser from "apis/mutations/user/useLogin";
import useLoginCompany from "apis/mutations/company/useLogin";
import authAtom from "stores/auth";

const Form = () => {
  const [loginState, dispatch] = useInput({ userName: "", password: "" });
  const [loginType, setLoginType] = useState("user");
  const setAuth = useSetRecoilState(authAtom);
  const [errorMessage, setErrorMessage] = useState<
    undefined | string | string[]
  >("");

  // 일반회원 로그인 Api
  const loginUser = useLoginUser({
    onError: (message) => setErrorMessage(message),
    onSuccess: () => {
      setAuth({
        isLogin: true,
        type: "user",
      });
    },
  });

  // 전문가회원 로그인 Api
  const loginCompany = useLoginCompany({
    onError: (message) => setErrorMessage(message),
    onSuccess: () => {
      setAuth({
        isLogin: true,
        type: "company",
      });
    },
  });

  const { userName, password } = loginState;

  // 로그인
  const handleLogin = (e: InputForm) => {
    e.preventDefault();
    if (!userName) return;
    if (!password) return;

    if (loginType === "user") {
      loginUser(loginState);
    } else {
      loginCompany(loginState);
    }
  };

  return (
    <form onSubmit={handleLogin}>
      <div className="flex items-center gap-4 mb-5">
        <InputRadio
          name="loginType"
          value="user"
          labelText="일반회원"
          onChange={() => setLoginType("user")}
          checked={loginType === "user"}
        />
        <InputRadio
          name="loginType"
          value="company"
          labelText="전문가회원"
          onChange={() => setLoginType("company")}
          checked={loginType === "company"}
        />
      </div>
      <InputText
        placeholder="아이디"
        className={{ container: "mb-3" }}
        value={userName}
        onChange={(event) => dispatch({ event })}
        name="userName"
        shape="square"
      />
      <InputText
        placeholder="비밀번호"
        type="password"
        value={password}
        onChange={(event) => dispatch({ event })}
        name="password"
        shape="square"
      />
      {errorMessage && (
        <p className="mt-1 ml-2 text-error-active">{errorMessage}</p>
      )}
      <Buttons.Blue size="large" className="mt-5 mx-auto w-full">
        로그인
      </Buttons.Blue>
    </form>
  );
};

export default Form;
